// extracted by mini-css-extract-plugin
module.exports = {"box":"_898187","box_padding":"_4febe6"};